export default "/fonts/line-awesome.ttf?09dc31126068bedb290b1efed5216b26";